import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    // send the error to New Relic if New Relic exists
    if ((window as any).newrelic && (window as any).newrelic?.noticeError) {
      (window as any).newrelic.noticeError(error);
    }
    console.error(error);
    // throw the error to allow the default error handler to process it
    throw error;
  }
}
